/* eslint-disable */
import React, { FC, useEffect, useRef } from 'react';
import i18n from '~/i18n';
import { Switch, Route } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { usePageTitle } from '~/context/PageTitleContext';
import { useSelector } from 'react-redux';
import CompanyTypeLayout from '~/layouts/CompanyTypeLayout';
import AgentLayout from '~/layouts/AgentLayout';
import merchantInviteAuthCallback from '~/pages/merchantInviteAuthCallback';
import agentAuthCallback from '~/pages/agentAuthCallback';
import { getPortalType, getShouldGoToDashboard } from '~/utils/getShouldGoToDashboard';
import paths from './paths';

import home from './home';
import merchantAuthCallback from './merchantAuthCallback';
import wizard from './uae';
import services from './uae/services';
import application from './uae/application';
import dataValidation from './ksa/dataValidation/DataValidation';
import dataValidationSmsOtp from './ksa/dataValidation/SmsOtpPage';
import dataValidationError from './ksa/dataValidation/ErrorPage';
import dataValidationGetStarted from './ksa/dataValidation/GetStarted';
import invitation from './ksa/invitation/Invitation';
import invitationSmsOtp from './ksa/invitation/SmsOtpPage';
import invitationError from './ksa/invitation/ErrorPage';
import invitationExistingUser from './ksa/invitation/ExistingUser';
import invitationNewUser from './ksa/invitation/AcceptInvitationOne';
import signContract from './uae/signContract';
import payment from './uae/payment';
import completion from './uae/completion';
import companyType from './uae/companyType';
import letsStart from './uae/letsStart';
import getInTouch from './uae/getInTouch';
import waitingForScreening from './stageResult/waitingForScreening';
import error from './stageResult/error';
import screeningError from './stageResult/screeningError';
import screeningReject from './stageResult/screeningReject';
import salesforceSoftDecline from './stageResult/salesforceSoftDecline';
import salesforceHardDecline from './stageResult/salesforceHardDecline';
import submit from './stageResult/submit';
import salesforceError from './stageResult/salesforceError';
import salesforceTechnicalError from './stageResult/salesforceTechnicalError';
import successfulOnboarding from './stageResult/successfulOnboarding';
import completed from './stageResult/completed';
import unknownStage from './stageResult/unknownStage';
import agent from './agent';
import leads from './agent/leads';
import applications from './agent/applications';
import agentMap from './agent/map';
import redirectToApplication from './redirect/application';
import homeApplication from './application';

// ksa pages
import ksaFlow from './ksa';
import ksaApplication from './ksa/application';
import ksaReview from './ksa/review';
import ksaReviewSuccess from './ksa/completion/reviewSuccess';
import ksaReviewReject from './ksa/completion/reviewReject';
import ksaReviewResubmit from './ksa/completion/reviewResubmit';
import ksaTerminated from './ksa/completion/terminated';
import ksaServices from './ksa/services';
import ksaInitialInformation from './ksa/initialInformation';
import ksaStartInMinutes from './ksa/services/StartInMinutes';
import ksaContract from './ksa/contract';
import ksaPayment from './ksa/payment';
import ksaCompletion from './ksa/completion';
import KsaContactUs from './ksa/contactUs';
import sales from './sales';
import salesTable from './sales/table';
import SalesDashboardLayout from '~/layouts/ksa/SalesDashboardLayout';

import WizardLayout from '../layouts/uae/WizardLayout';
import KsaLayout from '../layouts/ksa/KsaLayout';
import CompanyInfoLayout from '../layouts/ksa/CompanyInfoLayout';
import { LayoutBackgroundImage } from './ksa/dataValidation/components/Context';
import { getDecodedJwt } from '~/utils/getDecodedJwt';
import { getTrackingId } from '~/utils/handleGetUtm';
import { useGetApplication } from '~/controllers/wizard';

const pages = {
  auth: [
    {
      path: paths.auth.merchantAuthCallback,
      exact: true,
      component: merchantAuthCallback,
    },
    {
      path: paths.auth.merchantInviteAuthCallback,
      exact: true,
      component: merchantInviteAuthCallback,
    },
    {
      path: paths.auth.agentAuthCallback,
      exact: true,
      component: agentAuthCallback,
    },
  ],
  redirect: [
    {
      path: `${paths.redirect.application}/:applicationId`,
      exact: true,
      component: redirectToApplication,
    },
  ],
  wizard: [
    {
      path: paths.wizard._,
      exact: true,
      component: wizard,
    },
    {
      path: paths.wizard.services,
      exact: true,
      component: services,
    },
    {
      path: `${paths.wizard.application}`,
      exact: false,
      component: application,
    },
    {
      path: paths.wizard.signContract,
      exact: true,
      component: signContract,
    },
    {
      path: paths.wizard.payment,
      exact: true,
      component: payment,
    },
  ],
  stageResult: [
    {
      path: paths.stageResult.waitingForScreening,
      exact: true,
      component: waitingForScreening,
    },
    {
      path: paths.stageResult.error,
      exact: true,
      component: error,
    },
    {
      path: paths.stageResult.screeningError,
      exact: true,
      component: screeningError,
    },
    {
      path: paths.stageResult.screeningReject,
      exact: true,
      component: screeningReject,
    },
    {
      path: paths.stageResult.submit,
      exact: true,
      component: submit,
    },
    {
      path: paths.stageResult.salesforceError,
      exact: true,
      component: salesforceError,
    },
    {
      path: paths.stageResult.salesforceTechnicalError,
      exact: true,
      component: salesforceTechnicalError,
    },
    {
      path: paths.stageResult.salesforceSoftDecline,
      exact: true,
      component: salesforceSoftDecline,
    },
    {
      path: paths.stageResult.salesforceHardDecline,
      exact: true,
      component: salesforceHardDecline,
    },
    {
      path: paths.stageResult.successfulOnboarding,
      exact: true,
      component: successfulOnboarding,
    },
    {
      path: paths.stageResult.completed,
      exact: true,
      component: completed,
    },
    {
      path: paths.stageResult.unknownStage,
      exact: true,
      component: unknownStage,
    },
  ],
  app: [
    {
      path: paths.home._,
      exact: true,
      component: home,
    },
    {
      path: paths.home.application,
      exact: true,
      component: homeApplication,
    },
  ],
  companyType: [
    {
      path: paths.companyType._,
      exact: true,
      component: companyType,
    },
  ],
  letsStart: [
    {
      path: paths.letsStart._,
      exact: true,
      component: letsStart,
    },
  ],
  getInTouch: [
    {
      path: paths.getInTouch._,
      exact: true,
      component: getInTouch,
    },
  ],
  agent: [
    {
      path: paths.agent._,
      exact: true,
      component: agent,
    },
    {
      path: paths.agent.leads,
      exact: true,
      component: leads,
    },
    {
      path: paths.agent.applications,
      exact: true,
      component: applications,
    },
    {
      path: paths.agent.map,
      exact: true,
      component: agentMap,
    },
  ],
  sales: [
    {
      path: paths.sales._,
      exact: true,
      component: sales,
    },
    {
      path: paths.sales.table,
      exact: true,
      component: salesTable,
    },
  ],
  ksaOnboarding: [
    {
      path: paths.ksa.dataValidation._,
      exact: true,
      component: dataValidation,
    },
    {
      path: paths.ksa.dataValidation.smsotp,
      exact: true,
      component: dataValidationSmsOtp,
    },
    {
      path: paths.ksa.dataValidation.error,
      exact: true,
      component: dataValidationError,
    },
  ],
  ksaInvite: [
    {
      path: paths.ksa.invitation._,
      exact: true,
      component: invitation,
    },
    {
      path: paths.ksa.invitation.smsotp,
      exact: false,
      component: invitationSmsOtp,
    },
    {
      path: paths.ksa.invitation.error,
      exact: false,
      component: invitationError,
    },
    {
      path: paths.ksa.invitation.existingUser,
      exact: true,
      component: invitationExistingUser,
    },
    {
      path: paths.ksa.invitation.letsStart,
      exact: true,
      component: invitationNewUser,
    },
  ],
  ksa: [
    {
      path: paths.ksa._,
      exact: true,
      component: ksaFlow,
    },
    {
      path: paths.ksa.application,
      exact: false,
      component: ksaApplication,
    },
    {
      path: paths.ksa.review,
      exact: false,
      component: ksaReview,
    },
    {
      path: paths.ksa.reviewSuccess,
      exact: false,
      component: ksaReviewSuccess,
    },
    {
      path: paths.ksa.reviewReject,
      exact: false,
      component: ksaReviewReject,
    },
    {
      path: paths.ksa.terminated,
      exact: false,
      component: ksaTerminated,
    },
    {
      path: paths.ksa.reviewResubmit,
      exact: false,
      component: ksaReviewResubmit,
    },
    {
      path: paths.ksa.startInMinutes,
      exact: true,
      component: ksaStartInMinutes,
    },
    {
      // Step 1: Select Products
      path: paths.ksa.services,
      exact: false,
      component: ksaServices,
    },
    {
      // Step 2: Initial Information (DataValidation with sidebar nav)
      path: paths.ksa.initialInformation,
      exact: true,
      component: ksaInitialInformation,
    },
    {
      path: paths.ksa.contract,
      exact: false,
      component: ksaContract,
    },
    {
      path: paths.ksa.payment,
      exact: false,
      component: ksaPayment,
    },
    {
      path: paths.ksa.completion,
      exact: false,
      component: ksaCompletion,
    },
    {
      path: paths.ksa.contactUs,
      exact: false,
      component: KsaContactUs,
    },
    // {
    //   path: paths.ksa.nafath,
    //   exact: true,
    //   component: ksaNafath,
    // },
  ],
  getStarted: [
    {
      path: paths.ksa.getStarted._,
      exact: true,
      component: dataValidationGetStarted,
    },
  ],
};

const Pages: FC = () => {
  const location = useLocation();
  const { pageTitle, setPageTitle } = usePageTitle();
  // const history = useHistory();
  const token = getDecodedJwt();
  const { data }: any = useGetApplication({ enabled: !!token });
  // const utm =
  //   localStorage.getItem('utm-saved-param') ||
  //   data?.payload?.initialInfo?.utm ||
  //   localStorage.getItem('redirectUrlParams') ||
  //   localStorage.getItem('utmUrlState') ||
  //   localStorage.getItem('urlParams');
  //
  // // const finalUtm = JSON.parse(utm || '{}');
  // const finalUtm: any = { utm_campaign: 'test', utm_source: 'test', trackingId: 'test' };
  // const trackingId: any = localStorage.getItem('tracking_id') || finalUtm?.trackingId;
  // const utmParams = Object.entries({ ...finalUtm, trackingId } || {})
  //   .map(([key, value]: any) => {
  //     return `${key}=${value}`;
  //   })
  //   ?.join('&');

  // console.log('heeeeey');
  // const utm =
  //   localStorage.getItem('utm-saved-param') ||
  //   data?.payload?.initialInfo?.utm ||
  //   localStorage.getItem('redirectUrlParams') ||
  //   localStorage.getItem('utmUrlState') ||
  //   localStorage.getItem('urlParams');
  //
  // const finalUtm = JSON.parse(utm || '{}');
  // console.log('finalUtm', finalUtm);
  // useEffect(() => {
  //   if (!finalUtm || Object.keys(finalUtm || {})?.length === 0 || location?.pathname === '/ksa')
  //     return;
  //   const trackingId: any = localStorage.getItem('tracking_id') || finalUtm?.trackingId;
  //   const searchParams = new URLSearchParams(location.search);
  //   let changed = false;
  //   Object.entries(finalUtm || {}).forEach(([key, value]: any) => {
  //     if (value && !searchParams.has(key)) {
  //       searchParams.set(key, value);
  //       changed = true;
  //     }
  //   });
  //   searchParams.set('trackingId', trackingId || '');
  //   if (changed) {
  //     history.replace({
  //       pathname: location.pathname,
  //       search: searchParams.toString(),
  //     });
  //   }
  // }, [location?.pathname, JSON.stringify(finalUtm)]);

  // Tracks which pathname has already had its GTM event fired — prevents duplicate events
  const firedForPathname = useRef<string | null>(null);

  const splitCamelCase = (str: string) => {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // Reset the fired-guard whenever the route changes so the next page can fire once
  useEffect(() => {
    firedForPathname.current = null;
  }, [location?.pathname]);

  // Fire GTM event exactly once per page — only after ContentHeader sets the real title
  useEffect(() => {
    if (!pageTitle) return; // wait for ContentHeader to mount
    if (!location?.pathname?.startsWith('/ksa')) return; // only on /ksa routes

    // Use pathname+title as composite key: prevents stale title from previous page
    // firing on the new route during React's unmount/mount overlap
    const fireKey = `${location.pathname}::${pageTitle}`;
    if (firedForPathname.current === fireKey) return; // already fired for this page+title

    firedForPathname.current = fireKey; // mark as fired
    document.title = pageTitle;
    const eventPayload = {
      event: 'event_pageview',
      page_ln: i18n.language?.slice(0, 2) || 'en',
      page_title: pageTitle,
      page_name: window.location.href,
      page_source: document.referrer || 'direct',
      trackingId: getTrackingId(data) || '',
    };
    (window as any).dataLayer.push(eventPayload);
  }, [pageTitle]);
  return (
    <Switch>
      {getRoutes(pages.auth)}
      {getRoutes(pages.redirect)}
      {getRoutes(pages.app)}
      <Route path={paths.sales._}>
        {() =>
          getPortalType() === 'sales' ? (
            <SalesDashboardLayout>{getRoutes(pages.sales)}</SalesDashboardLayout>
          ) : (
            <Route component={home} />
          )
        }
      </Route>
      <Route path={paths.agent._}>
        {() =>
          getShouldGoToDashboard() ? (
            <AgentLayout>{getRoutes(pages.agent)}</AgentLayout>
          ) : (
            <Route component={home} />
          )
        }
      </Route>
      <Route path={paths.home.application} component={application} />
      <Route path={paths.companyType._}>
        <CompanyTypeLayout image="default">{getRoutes(pages.companyType)}</CompanyTypeLayout>
      </Route>
      <Route path={paths.getInTouch._}>
        <CompanyTypeLayout image="default">{getRoutes(pages.getInTouch)}</CompanyTypeLayout>
      </Route>
      <Route path={paths.letsStart._}>
        <CompanyTypeLayout image="success">{getRoutes(pages.letsStart)}</CompanyTypeLayout>
      </Route>
      <Route path={paths.wizard._}>
        <WizardLayout>{getRoutes(pages.wizard)}</WizardLayout>
      </Route>
      <Route path={paths.stageResult._}>
        <WizardLayout>{getRoutes(pages.stageResult)}</WizardLayout>
      </Route>

      <Route path={paths.ksa.dataValidation._}>
        <WizardLayout>{getRoutes(pages.ksaOnboarding)}</WizardLayout>
      </Route>
      <Route path={paths.ksa.getStarted._}>
        <CompanyInfoLayout image={LayoutBackgroundImage.SUCCSESS}>
          {getRoutes(pages.getStarted)}
        </CompanyInfoLayout>
      </Route>
      <Route path={paths.ksa.invitation._}>
        <CompanyInfoLayout>{getRoutes(pages.ksaInvite)}</CompanyInfoLayout>
      </Route>
      <Route path={paths.ksa._}>
        <WizardLayout>{getRoutes(pages.ksa)}</WizardLayout>
      </Route>
    </Switch>
  );
};

type RouteConfig = {
  path: string;
  exact: boolean;
  component: any;
};

const getRoutes = (routes: RouteConfig[], utmParams?: string) => {
  return routes.map((route) => {
    const { path, exact, component } = route;
    return <Route path={path} key={path} exact={exact} component={component} />;
  });
};

export default Pages;
